// UI translations. English is the source of truth; every other
// language falls back to English for any missing key.

const translations = {
  en: {
    // Nav
    'nav.home': 'Home',
    'nav.services': 'Services',
    'nav.work': 'Work',
    'nav.analytics': 'Analytics',
    'nav.pricing': 'Pricing',
    'nav.contact': 'Contact',
    'nav.getStarted': 'Get Started',

    // Hero / CTAs
    'cta.getDemo': 'Get a demo',
    'cta.exploreServices': 'Explore services',
    'cta.startProject': 'Start a project',
    'cta.getStarted': 'Get started',

    // Footer
    'footer.services': 'Services',
    'footer.company': 'Company',
    'footer.resources': 'Resources',
    'footer.analyticsDemo': 'Analytics Demo',
    'footer.caseStudies': 'Case Studies',
    'footer.techStack': 'Technology Stack',
    'footer.getQuote': 'Get a Quote',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Service',
    'footer.cookies': 'Cookie Policy',
    'footer.rights': 'All rights reserved.',
    'footer.poweredBy': 'Powered by SynchronicTech',
    'footer.region': 'Region',

    // Pricing
    'pricing.eyebrow': 'Pricing',
    'pricing.title': 'Clear plans that',
    'pricing.accent': 'scale with you.',
    'pricing.intro': 'Every plan includes a consultation and project discovery phase. No surprises.',
    'pricing.mostPopular': 'Most Popular',
    'pricing.oneTime': 'one-time',
    'pricing.custom': 'Custom',
    'pricing.customPricing': 'pricing',
    'pricing.note': 'Custom solutions available for enterprise needs.',
    'pricing.localNote': 'Prices shown in your local currency (approximate, billed in USD).',

    // Contact
    'contact.eyebrow': 'Contact',
    'contact.title': "Let's get your project",
    'contact.accent': 'in sync.',
    'contact.intro': "Web development, analytics, or automation — tell us what you need and we'll take it from there.",
    'contact.reachUs': 'Reach us directly',
    'contact.letsConnect': "Let's connect",
    'contact.blurb': "Whether you need web development, data analytics, or automation, we're here to help your business thrive in the digital age.",
    'contact.email': 'Email',
    'contact.yourName': 'Your name',
    'contact.yourEmail': 'Your email',
    'contact.message': 'Message',
    'contact.send': 'Send message',
    'contact.sending': 'Sending…',
  },

  es: {
    'nav.home': 'Inicio',
    'nav.services': 'Servicios',
    'nav.work': 'Proyectos',
    'nav.analytics': 'Analítica',
    'nav.pricing': 'Precios',
    'nav.contact': 'Contacto',
    'nav.getStarted': 'Comenzar',
    'cta.getDemo': 'Solicitar demo',
    'cta.exploreServices': 'Ver servicios',
    'cta.startProject': 'Iniciar un proyecto',
    'cta.getStarted': 'Comenzar',
    'footer.services': 'Servicios',
    'footer.company': 'Empresa',
    'footer.resources': 'Recursos',
    'footer.analyticsDemo': 'Demo de analítica',
    'footer.caseStudies': 'Casos de éxito',
    'footer.techStack': 'Tecnologías',
    'footer.getQuote': 'Pedir presupuesto',
    'footer.privacy': 'Política de privacidad',
    'footer.terms': 'Términos del servicio',
    'footer.cookies': 'Política de cookies',
    'footer.rights': 'Todos los derechos reservados.',
    'footer.poweredBy': 'Impulsado por SynchronicTech',
    'footer.region': 'Región',
    'pricing.eyebrow': 'Precios',
    'pricing.title': 'Planes claros que',
    'pricing.accent': 'crecen contigo.',
    'pricing.intro': 'Cada plan incluye una consultoría y una fase de descubrimiento. Sin sorpresas.',
    'pricing.mostPopular': 'Más popular',
    'pricing.oneTime': 'pago único',
    'pricing.custom': 'A medida',
    'pricing.customPricing': 'precio',
    'pricing.note': 'Soluciones a medida disponibles para empresas.',
    'pricing.localNote': 'Precios en tu moneda local (aproximados, facturados en USD).',
    'contact.eyebrow': 'Contacto',
    'contact.title': 'Pongamos tu proyecto',
    'contact.accent': 'en marcha.',
    'contact.intro': 'Desarrollo web, analítica o automatización: cuéntanos qué necesitas y nos encargamos del resto.',
    'contact.reachUs': 'Contáctanos directamente',
    'contact.letsConnect': 'Conectemos',
    'contact.blurb': 'Ya sea desarrollo web, analítica de datos o automatización, estamos aquí para ayudar a tu negocio a crecer en la era digital.',
    'contact.email': 'Correo',
    'contact.yourName': 'Tu nombre',
    'contact.yourEmail': 'Tu correo',
    'contact.message': 'Mensaje',
    'contact.send': 'Enviar mensaje',
    'contact.sending': 'Enviando…',
  },

  fr: {
    'nav.home': 'Accueil',
    'nav.services': 'Services',
    'nav.work': 'Réalisations',
    'nav.analytics': 'Analytique',
    'nav.pricing': 'Tarifs',
    'nav.contact': 'Contact',
    'nav.getStarted': 'Commencer',
    'cta.getDemo': 'Demander une démo',
    'cta.exploreServices': 'Découvrir les services',
    'cta.startProject': 'Lancer un projet',
    'cta.getStarted': 'Commencer',
    'footer.services': 'Services',
    'footer.company': 'Entreprise',
    'footer.resources': 'Ressources',
    'footer.analyticsDemo': "Démo d'analytique",
    'footer.caseStudies': 'Études de cas',
    'footer.techStack': 'Technologies',
    'footer.getQuote': 'Obtenir un devis',
    'footer.privacy': 'Politique de confidentialité',
    'footer.terms': "Conditions d'utilisation",
    'footer.cookies': 'Politique de cookies',
    'footer.rights': 'Tous droits réservés.',
    'footer.poweredBy': 'Propulsé par SynchronicTech',
    'footer.region': 'Région',
    'pricing.eyebrow': 'Tarifs',
    'pricing.title': 'Des offres claires qui',
    'pricing.accent': 'évoluent avec vous.',
    'pricing.intro': 'Chaque offre inclut une consultation et une phase de cadrage. Sans surprise.',
    'pricing.mostPopular': 'Le plus populaire',
    'pricing.oneTime': 'paiement unique',
    'pricing.custom': 'Sur mesure',
    'pricing.customPricing': 'tarif',
    'pricing.note': 'Solutions sur mesure disponibles pour les entreprises.',
    'pricing.localNote': 'Prix affichés dans votre devise locale (approximatifs, facturés en USD).',
    'contact.eyebrow': 'Contact',
    'contact.title': 'Mettons votre projet',
    'contact.accent': 'en mouvement.',
    'contact.intro': 'Développement web, analytique ou automatisation : dites-nous ce dont vous avez besoin, nous nous occupons du reste.',
    'contact.reachUs': 'Contactez-nous directement',
    'contact.letsConnect': 'Échangeons',
    'contact.blurb': "Développement web, analyse de données ou automatisation : nous aidons votre entreprise à prospérer à l'ère du numérique.",
    'contact.email': 'E-mail',
    'contact.yourName': 'Votre nom',
    'contact.yourEmail': 'Votre e-mail',
    'contact.message': 'Message',
    'contact.send': 'Envoyer le message',
    'contact.sending': 'Envoi…',
  },

  de: {
    'nav.home': 'Start',
    'nav.services': 'Leistungen',
    'nav.work': 'Projekte',
    'nav.analytics': 'Analytik',
    'nav.pricing': 'Preise',
    'nav.contact': 'Kontakt',
    'nav.getStarted': 'Loslegen',
    'cta.getDemo': 'Demo anfragen',
    'cta.exploreServices': 'Leistungen entdecken',
    'cta.startProject': 'Projekt starten',
    'cta.getStarted': 'Loslegen',
    'footer.services': 'Leistungen',
    'footer.company': 'Unternehmen',
    'footer.resources': 'Ressourcen',
    'footer.analyticsDemo': 'Analytik-Demo',
    'footer.caseStudies': 'Fallstudien',
    'footer.techStack': 'Technologien',
    'footer.getQuote': 'Angebot anfordern',
    'footer.privacy': 'Datenschutz',
    'footer.terms': 'Nutzungsbedingungen',
    'footer.cookies': 'Cookie-Richtlinie',
    'footer.rights': 'Alle Rechte vorbehalten.',
    'footer.poweredBy': 'Powered by SynchronicTech',
    'footer.region': 'Region',
    'pricing.eyebrow': 'Preise',
    'pricing.title': 'Klare Pakete, die',
    'pricing.accent': 'mit Ihnen wachsen.',
    'pricing.intro': 'Jedes Paket beinhaltet eine Beratung und eine Discovery-Phase. Ohne Überraschungen.',
    'pricing.mostPopular': 'Am beliebtesten',
    'pricing.oneTime': 'einmalig',
    'pricing.custom': 'Individuell',
    'pricing.customPricing': 'Preis',
    'pricing.note': 'Individuelle Lösungen für Unternehmen verfügbar.',
    'pricing.localNote': 'Preise in Ihrer Landeswährung (Näherungswerte, Abrechnung in USD).',
    'contact.eyebrow': 'Kontakt',
    'contact.title': 'Bringen wir Ihr Projekt',
    'contact.accent': 'in den Takt.',
    'contact.intro': 'Webentwicklung, Analytik oder Automatisierung – sagen Sie uns, was Sie brauchen, wir kümmern uns um den Rest.',
    'contact.reachUs': 'Direkt erreichen',
    'contact.letsConnect': 'Sprechen wir',
    'contact.blurb': 'Ob Webentwicklung, Datenanalyse oder Automatisierung – wir helfen Ihrem Unternehmen, im digitalen Zeitalter zu wachsen.',
    'contact.email': 'E-Mail',
    'contact.yourName': 'Ihr Name',
    'contact.yourEmail': 'Ihre E-Mail',
    'contact.message': 'Nachricht',
    'contact.send': 'Nachricht senden',
    'contact.sending': 'Wird gesendet…',
  },

  pt: {
    'nav.home': 'Início',
    'nav.services': 'Serviços',
    'nav.work': 'Projetos',
    'nav.analytics': 'Analítica',
    'nav.pricing': 'Preços',
    'nav.contact': 'Contato',
    'nav.getStarted': 'Começar',
    'cta.getDemo': 'Pedir uma demo',
    'cta.exploreServices': 'Ver serviços',
    'cta.startProject': 'Iniciar um projeto',
    'cta.getStarted': 'Começar',
    'footer.services': 'Serviços',
    'footer.company': 'Empresa',
    'footer.resources': 'Recursos',
    'footer.analyticsDemo': 'Demo de analítica',
    'footer.caseStudies': 'Estudos de caso',
    'footer.techStack': 'Tecnologias',
    'footer.getQuote': 'Pedir orçamento',
    'footer.privacy': 'Política de privacidade',
    'footer.terms': 'Termos de serviço',
    'footer.cookies': 'Política de cookies',
    'footer.rights': 'Todos os direitos reservados.',
    'footer.poweredBy': 'Desenvolvido por SynchronicTech',
    'footer.region': 'Região',
    'pricing.eyebrow': 'Preços',
    'pricing.title': 'Planos claros que',
    'pricing.accent': 'crescem com você.',
    'pricing.intro': 'Todos os planos incluem consultoria e uma fase de descoberta. Sem surpresas.',
    'pricing.mostPopular': 'Mais popular',
    'pricing.oneTime': 'pagamento único',
    'pricing.custom': 'Sob medida',
    'pricing.customPricing': 'preço',
    'pricing.note': 'Soluções sob medida disponíveis para empresas.',
    'pricing.localNote': 'Preços na sua moeda local (aproximados, cobrados em USD).',
    'contact.eyebrow': 'Contato',
    'contact.title': 'Vamos colocar seu projeto',
    'contact.accent': 'em sincronia.',
    'contact.intro': 'Desenvolvimento web, analítica ou automação — diga o que você precisa e cuidamos do resto.',
    'contact.reachUs': 'Fale conosco diretamente',
    'contact.letsConnect': 'Vamos conversar',
    'contact.blurb': 'Seja desenvolvimento web, análise de dados ou automação, estamos aqui para ajudar seu negócio a prosperar na era digital.',
    'contact.email': 'E-mail',
    'contact.yourName': 'Seu nome',
    'contact.yourEmail': 'Seu e-mail',
    'contact.message': 'Mensagem',
    'contact.send': 'Enviar mensagem',
    'contact.sending': 'Enviando…',
  },
};

export default translations;
